import { render, staticRenderFns } from "./my-account-setting-profile.vue?vue&type=template&id=afeadd6c&scoped=true&"
import script from "./my-account-setting-profile.vue?vue&type=script&lang=js&"
export * from "./my-account-setting-profile.vue?vue&type=script&lang=js&"
import style0 from "./my-account-setting-profile.vue?vue&type=style&index=0&id=afeadd6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeadd6c",
  null
  
)

export default component.exports